$overlay-bg: rgb(1 1 1 / 60%);
$success-green: #22a06b;

body.sn-popup-type-1-open {
  overflow: hidden;
}

.sn-popup-type-1 {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: $overlay-bg;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: map-get($spacings, xl);
  z-index: -1;

  &--visible {
    opacity: 1;
    visibility: visible;
    z-index: 1001;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__body {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 52px 15px;
    background: $color-neutral-white;
    border-radius: map-get($border-radii, lg);
    box-shadow: 0 10px 30px rgb(0 0 0 / 25%);

    @include desktop {
      max-width: 500px;
      padding: 40px map-get($spacings, 2xl) map-get($spacings, 2xl);
    }
  }

  &__close {
    position: absolute;
    top: map-get($spacings, lg);
    right: map-get($spacings, lg);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background: none;
    border: none;
    border-radius: map-get($border-radii, sm);
    color: $color-neutral-neutral-darker;
    cursor: pointer;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: $color-neutral-neutral-darkest;
      background-color: $color-neutral-neutral-lightest;
    }

    &:focus-visible {
      outline: 2px solid $color-brand-primary-main;
      outline-offset: 2px;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: map-get($spacings, xl);
  }

  // `me-icon` drops its `width`/`height` props on the SSR-inlined path — `render()` returns
  // `<slot />` for `[data-inlined]` before those props become inline styles — and inlines the
  // raw sprite SVG without the `fill="currentColor"` the client path adds. So on a page the
  // icon fell back to the sprite's own 24px and to black. Size and color therefore come from
  // CSS here, which holds on both paths; the host needs `display` because a custom element is
  // inline by default and would ignore width/height.
  &__icon-svg {
    display: block;
    width: 50px;
    height: 50px;
    color: $success-green;

    .me-icon {
      width: 100%;
      height: 100%;
    }

    svg {
      fill: currentcolor;
    }
  }

  // Scoped via &__body (specificity 0,2,0) to beat the theme's
  // `[data-color-mode] h2 { font-family: graphik }` rule (0,1,1).
  &__body &__heading {
    margin: 0 0 map-get($spacings, 2xl);
    font-family: "Open Sans", Arial, sans-serif;
    font-size: map-get($font-sizes, xl);
    font-weight: map-get($font-weights, semi-bold);
    line-height: map-get($line-heights, 2xl);
    color: $color-neutral-neutral-darkest;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    width: 100%;

    @include desktop {
      flex-direction: row;
      justify-content: center;
    }
  }

  &__action {
    &.me-button {
      min-width: 200px;
    }
  }
}
